import { FunctionsHttpError } from "@supabase/supabase-js";
import { supabase } from "./supabase";

/** Resposta padrão das Edge Functions do WMS. */
export interface RespostaFuncao {
  ok: boolean;
  erro?: string;
  [chave: string]: unknown;
}

/**
 * Chama uma Edge Function e devolve o corpo quando ok. Resposta com erro (4xx/5xx
 * ou ok:false) vira exceção com a mensagem que a função mandou, não a genérica do cliente.
 */
export async function chamarFuncao<T extends RespostaFuncao = RespostaFuncao>(nome: string, corpo: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.functions.invoke(nome, { body: corpo });
  if (error) {
    if (error instanceof FunctionsHttpError) {
      const resposta = await (error.context as Response).json().catch(() => null) as RespostaFuncao | null;
      if (resposta?.erro) throw new Error(resposta.erro);
    }
    throw new Error(error.message || "Falha ao chamar o servidor");
  }
  const r = data as T | null;
  if (!r?.ok) throw new Error(r?.erro ?? "Operação recusada pelo servidor");
  return r;
}
